const TL_HANDLE_TYPES = /* @__PURE__ */ new Set(["vertex", "virtual", "create", "clone"]);
export {
  TL_HANDLE_TYPES
};
//# sourceMappingURL=TLHandle.mjs.map
